import React, { useState, useEffect } from 'react'
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../../customNavbar';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import { Col, Row, Image, Alert, Dropdown } from 'react-bootstrap';
import { CustomSearch } from '../../../shared/customSearch';
import { CustomButton } from '../../../shared/customButton';
import styles from './oneWayInterviewTemplates.module.scss';
import makeAnimated from 'react-select/animated';
import { copyOneWayInterviewTemplateToANew, getAllOneWayInterviewTemplates } from '../../../../services/util/oneWayInterviewTemplates';
import { useNavigate } from 'react-router-dom';
import { CreateOneWayInterviewTemplateModal } from './createOneWayInterviewModal'
import Select from 'react-select';
import CSSLoader from '../../../shared/cssLoader';
import { CustomCloneConfirmationBox } from '../../../shared/customCloneConfirmationBox';

let moment = require('moment-timezone');


const OneWayInterviewTemplates = (props) => {

    const animatedComponents = makeAnimated();
    const history = useNavigate();
    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let seleted_state = (params.get('state') ? params.get('state') : 100);
    let [getUsersIsLoading, getUsersSetLoading] = useState(false);
    let [filteredValues, setFilteredValues] = useState([]);
    let [value, setArrayValues] = useState([]);
    let [isURLLoading, setURLLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    let [noSearchData, setNoSearchData] = useState(false)
    let [isDataLoading, setIsDataLoading] = useState(false)
    let [getOneWayInterviewTemplate, getSetOneWayInterviewTemplate] = useState(false);

    let [selectedOneWayCloneID, setSelectedOneWayCloneID] = useState(null);
    let [isOneWayCloneModalOpen, setIsOneWayCloneModalOpen] = useState(false);
    const [isOneWayCloneSubmit, setIsOneWayCloneSubmit] = useState(false);


    //set an state for default seleted pipeline type
    let [defaultSelectedPipelineType, setDefaultSelectedPipelineType] = useState({
        label: "Active and Draft",
        value: 100
    })

    //dropdown values of pipeline types
    const pipelineTypes = [
        {
            label: "Active and Draft",
            value: 100
        },
        {
            label: "Active",
            value: 10
        },
        {
            label: "Draft",
            value: 0
        },
        {
            label: "Disabled",
            value: -10
        }
    ];

    // functions
    const handleClose = () => setShowModal(false);
    const handleShow = () => {
        setShowModal(true);
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99992C10.8334 9.53968 10.4603 9.16659 10.0001 9.16659C9.53984 9.16659 9.16675 9.53968 9.16675 9.99992C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 4.99992C10.4603 4.99992 10.8334 4.62682 10.8334 4.16659C10.8334 3.70635 10.4603 3.33325 10.0001 3.33325C9.53984 3.33325 9.16675 3.70635 9.16675 4.16659C9.16675 4.62682 9.53984 4.99992 10.0001 4.99992Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 16.6666C10.4603 16.6666 10.8334 16.2935 10.8334 15.8333C10.8334 15.373 10.4603 14.9999 10.0001 14.9999C9.53984 14.9999 9.16675 15.373 9.16675 15.8333C9.16675 16.2935 9.53984 16.6666 10.0001 16.6666Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    function viewOneWayInterviewTemplate(value) {
        history(`/company/interview-template/${value}`)
    }

    function editOneWayInterviewTemplate(value) {
        history(`/company/interview-template/${value}/edit`);
    }
    function cloneWayInterviewTemplate(value) {
        setIsOneWayCloneModalOpen(true);
        setSelectedOneWayCloneID(value)
    }
    //submit clone values function
    async function submitOneWayCloneValues(values) {
        setIsOneWayCloneSubmit(true)
        let respond = await copyOneWayInterviewTemplateToANew(selectedOneWayCloneID, values.newCloneName)
        if (respond.success === true) {
            history(`/company/interview-template/${respond.data.new_one_way_interview_template_id}/edit`);
            handleClose();
            setSelectedOneWayCloneID(null);
            setIsOneWayCloneSubmit(false);
            setIsOneWayCloneModalOpen(false);
        } else {
            setIsOneWayCloneSubmit(false);
            setIsOneWayCloneModalOpen(false);
        }
        getAllOneWayInterviewTemplateDetails();
    }



    const getAllOneWayInterviewTemplateDetails = async () => {
        getUsersSetLoading(true)
        let response = await getAllOneWayInterviewTemplates(seleted_state);
        if (response.success == true) {
            //setting pipleine label for selected state
            if (seleted_state != 100) {
                for (let index = 0; index < pipelineTypes.length; index++) {
                    if (pipelineTypes[index].value == seleted_state) {
                        setDefaultSelectedPipelineType(pipelineTypes[index]);

                    }
                }
            }
            setArrayValues(response.data);
            setFilteredValues(response.data);
            getUsersSetLoading(false)
        } else {
            getUsersSetLoading(false)
        }
    }

    const changePipelineType = async (type) => {
        getUsersSetLoading(true);
        setDefaultSelectedPipelineType(type);
        let respond = await getAllOneWayInterviewTemplates(type.value);
        if (respond.success === true) {
            setFilteredValues(respond.data);
            getUsersSetLoading(false)
        } else {
            getUsersSetLoading(false)
        }

    };

    const changeSelectedStateURL = async (state) => {
        history({
            pathname: `/company/templates/one-way-interview-templates`,
            search: `?state=${state}`
        });
        setCurrentPage(1);
    }

    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = value.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
        if (filtered.length === 0) {
            setNoSearchData(true)
        }
        setCurrentPage(1);
    }


    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
    useEffect(() => {
        getAllOneWayInterviewTemplateDetails();
    }, [])

    return (
        <div >
            <Helmet>
                <title>One Way Interview Templates | HireTrace</title>
            </Helmet>
            {/* oneway clone modal start */}
            {
                <CustomCloneConfirmationBox
                    show={isOneWayCloneModalOpen}
                    confirmationType='default'
                    cancelIconclick={() => setIsOneWayCloneModalOpen(false)}
                    onSecondaryBtnClick={() => setIsOneWayCloneModalOpen(false)}
                    onFormSubmit={submitOneWayCloneValues}
                    isSecondaryBtnDisabled={isOneWayCloneSubmit === true ? true : false}
                    isPrimaryBtnDisabled={isOneWayCloneSubmit === true ? true : false}
                    primaryBtnBackSideIcon={isOneWayCloneSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                    preCheckedCondition={true}
                    topic="Clone One-Way Interview Template"
                    message={`We will create an exact same copy of the selected template, but you can set a different name.`}
                    textBoxLabel={`New Template Name`}
                    secondaryBtnName="backBtn"
                    secondaryBtnType="button"
                    secondaryBtnCssType="primaryBtn"
                    secondaryBtnLabel="Cancel"
                    primaryBtnName="submitCloneBtn"
                    primaryBtnType="submit"
                    primaryBtnCssType="successBtn"
                    primaryBtnLabel="Yes, Clone Template"
                    textBoxPlaceholder={`Ex: Software Engineer One-Way Interview`}
                />}
            {/* oneway clone modal end */}
            {
                showModal === true ?
                    <CreateOneWayInterviewTemplateModal show={showModal} handleClose={handleClose} stepLength={3} />
                    : null
            }
            {getUsersIsLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                <div>
                    <div className={styles.backgroundFixedComponents}>
                        <Col>
                            <div>
                                <Row>
                                    <Col sm={2} className="mb-2">
                                        <Select
                                            options={pipelineTypes}
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={defaultSelectedPipelineType}
                                            onChange={(e) => {
                                                changePipelineType(e);
                                                changeSelectedStateURL(e.value)
                                            }}
                                            styles={
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                        border: '1px solid #bdbdbd', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                        height: '45px',
                                                        fontFamily: 'var(--app-primary-font-style)',
                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                        fontSize: 'var(--app-primary-font-size)',
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                }
                                            }
                                        />
                                    </Col>
                                    <Col sm={6} className="mb-2">
                                        <CustomSearch
                                            placeholder="Search One Way Interview Templates"
                                            handleOnChange={(e) => searchValus(e.target.value)}
                                        />
                                    </Col>
                                    <Col>
                                    </Col>
                                    <Col sm={3} className="mb-2">
                                        <CustomButton
                                            buttonType="button"
                                            label="Create New One-way Interview"
                                            type="primaryBtn"
                                            id="adminPanel_evaluationTemplates_oneWayInterviewTemplates_createNewOneWayInterviewBtnId"
                                            frontIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M9.99996 4.1665V15.8332M4.16663 9.99984H15.8333" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            handleClick={handleShow}

                                        />
                                    </Col>
                                </Row>
                            </div>

                        </Col>
                    </div>

                    <div className={styles.tableBodyContainer}>
                        {
                            ((filteredValues.length === 0) && (getUsersIsLoading === false)) ?
                                (<div>
                                    {noSearchData ?
                                        <Col>
                                            <p className={styles.infoMessage}>No records found for your search, Try a different keyword. </p>
                                        </Col>
                                        :
                                        <div>
                                            <Col>
                                                <p className={styles.infoMessage}>You haven't created any One Way Interview Templates yet. Create now.
                                                </p>
                                            </Col>
                                            <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                                <div className={styles.noQuizImg}>
                                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/quiz.svg`} fluid />
                                                </div>

                                            </Col>
                                        </div>


                                    }

                                </div>)
                                :
                                (<div className={styles.tableContainer}>
                                    <div className={styles.interviewFirstRowMainHeaderDiv}>
                                        <Col sm={4} className={styles.interviewPipelineDetailsMainHeaderRow}>
                                            <p>Template Name</p>
                                        </Col>
                                        <Col sm={2}>
                                            <Row className={styles.interviewInfoDetailsMainHeaderRow}>
                                                <p>Avg. Duration / Ques. Count</p>
                                            </Row>
                                        </Col>
                                        <Col sm={1} className={styles.interviewStstusDetailsMainHeaderRowStatus}>
                                            <p>Status</p>
                                        </Col>
                                        <Col sm={2}>
                                            <Row className={styles.interviewCandidatesInfoDetailsHeaderRow}>
                                                <p>Last Updated at</p>
                                            </Row>
                                        </Col>
                                        <Col sm={2} className={styles.interviewStstusDetailsMainHeaderRow}>
                                            <p>Attached Active Pipelines</p>
                                        </Col>
                                        <Col sm={1}>
                                        </Col>
                                    </div>
                                    {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((interview, i) => {
                                        return (
                                            <div className={i % 2 === 0 ? styles.interviewRowMainDiv : styles.interviewRowSecondMainDiv} >
                                                <Col sm={4} id={`adminPanel_evaluationTemplates_oneWayInterviewTemplates_tableTemplateRowId.${i}`} >
                                                    <Row className={styles.interviewJobDetailsMainRow} onClick={() => editOneWayInterviewTemplate(interview?.one_way_interview_template_id)}>
                                                        <Col sm={1}>
                                                            <div className={styles.interviewMainIconDiv}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M23 7L16 12L23 17V7Z" stroke="#2DA6C0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M14 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H14C15.1046 19 16 18.1046 16 17V7C16 5.89543 15.1046 5 14 5Z" stroke="#2DA6C0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </div>
                                                        </Col>
                                                        <Col sm={10} className='ms-4 mt-2'>
                                                            <Row className={styles.interviewJobDetailsRow}>
                                                                <p className={styles.interviewSecondJobDetails} id={`adminPanel_evaluationTemplates_oneWayInterviewTemplates_templateNameInTable.${i}`}>{interview?.template_name}</p>
                                                            </Row>
                                                        </Col>

                                                    </Row>
                                                </Col>
                                                <Col sm={1}>
                                                    <Row className={styles.interviewCandidatesLastUpdateDetailsQuizTimeRow}>
                                                        <p className={styles.interviewCandidatesLastUpdateDetails}>
                                                            <span id={`adminPanel_evaluationTemplates_oneWayInterviewTemplates_avgDurationInTable.${i}`}>{interview?.overall_question_time ? interview?.overall_question_time : '0'}min</span> &nbsp;&nbsp;/ &nbsp;&nbsp;
                                                            <span id={`adminPanel_evaluationTemplates_oneWayInterviewTemplates_questionCountInTable.${i}`}>
                                                                {interview?.question_count === 0 ? '0' : `${interview?.question_count}`}
                                                            </span>

                                                        </p>
                                                    </Row>
                                                </Col>
                                                <Col sm={2}>
                                                    <Row className={styles.interviewCandidatesLastUpdateDetailsRow}>
                                                        <p className={styles.interviewCandidatesLastUpdateDetailsStatus}>
                                                            <div className={interview.state === 10 ? styles.interviewStatusDetailsMainDiv : interview.state === 0 ? styles.interviewStatusDetailsDraftMainDiv : styles.interviewStatusDetailsDisableMainDiv} id={`adminPanel_evaluationTemplates_oneWayInterviewTemplates_templateStatusInTable.${i}`}>
                                                                {interview.state === 10 ? <p className={styles.interviewStatusDetails}>Active</p> : interview.state === 0 ? <p className={styles.interviewStatusDraftDetails}>Draft</p> : interview.state === -10 ? <p className={styles.interviewStatusDraftDetails}>Disable</p> : null}
                                                            </div>
                                                        </p>
                                                    </Row>
                                                </Col>
                                                <Col sm={2}>
                                                    <Row className={styles.interviewCandidatesLastUpdateDetailsRow}>
                                                        <p className={styles.interviewCandidatesLastUpdateDetails}>
                                                            {moment.tz(interview.last_updated_at, moment.tz.guess()).format('DD MMM YYYY, HH:mmA')}
                                                        </p>
                                                    </Row>
                                                </Col>
                                                <Col sm={2}>
                                                    <Row className={styles.interviewCandidatesLastUpdateDetailsRow}>
                                                     <p className={styles.interviewCandidatesLastUpdateDetails}>{interview?.active_pipeline_count}</p>
                                                    </Row>
                                                </Col>
                                                <Col sm={1}>
                                                    <Row className={styles.quizOptionRow}>
                                                        <div className={styles.quizOptionIconDiv}>
                                                            <Dropdown
                                                                alignRight={true}
                                                            >
                                                                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className={styles.dropdownMenu}>
                                                                    <Dropdown.Item onClick={() => editOneWayInterviewTemplate(interview?.one_way_interview_template_id)} className={styles.dropdownText}>View</Dropdown.Item>
                                                                    <Dropdown.Item onClick={() => cloneWayInterviewTemplate(interview?.one_way_interview_template_id)} className={styles.dropdownText}>clone</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </div>
                                        )
                                    })
                                    }
                                    {filteredValues.length > 9 && getUsersIsLoading === false &&
                                        <div className={styles.bottomTableDiv}>
                                            <div>
                                                <button
                                                    onClick={handlePreviousClick}
                                                    disabled={currentPage === 1}
                                                    className={styles.paginationPrevButton}
                                                >
                                                    Previous
                                                </button>
                                                <button
                                                    onClick={handleNextClick}
                                                    disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                                    className={styles.paginationNextButton}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                            <div>
                                                <span className={styles.paginationInfo}>
                                                    Page {currentPage} of {totalPages}
                                                </span>
                                            </div>

                                        </div>
                                    }
                                </div>)
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default OneWayInterviewTemplates